import React from 'react';
import { Spinner, Table } from 'react-bootstrap';

import Card from 'components/DesignSystem/Card';
import { formatNumberBR } from 'components/Relatorios/shared/RelatorioTable';

import useSemanalSecaoParams from 'hooks/Relatorios/Semanal/useSemanalSecaoParams';
import { useGetSemanalCargaQuery } from 'services/api/products/relatorios';

export default function Carga() {
  const params = useSemanalSecaoParams();

  const { data, isLoading } = useGetSemanalCargaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  // Cabeçalho de 2 níveis (grupo de métrica x mês) — mesmo padrão da tabela "Preços"
  // do Resultados DECOMP (colSpan/rowSpan direto, fora do RelatorioTable genérico).
  const grupos = data.linhas[0]?.colunas.map((c) => c.grupo) ?? [];

  return (
    <Card title={data.titulo} className="relatorio-table">
      <Table responsive hover>
        <thead>
          <tr>
            <th rowSpan={2}>Subsistema</th>
            {grupos.map((grupo) => (
              <th key={grupo} colSpan={data.meses.length}>{grupo}</th>
            ))}
          </tr>
          <tr>
            {grupos.map((grupo) => data.meses.map((mes) => (
              <th key={`${grupo}-${mes}`}>{mes}</th>
            )))}
          </tr>
        </thead>
        <tbody>
          {data.linhas.map((linha) => (
            <tr key={linha.subsistema}>
              <td>{linha.subsistema}</td>
              {linha.colunas.map((coluna) => coluna.valores.map((valor, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <td key={`${linha.subsistema}-${coluna.grupo}-${i}`}>
                  {formatNumberBR(valor)}
                </td>
              )))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
}
